import { Button, Divider, Icon, Popconfirm, Spin } from 'antd'
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'
import { useUserWithRedirect } from '../../hooks/user/useUserWithRedirect'
import PackageAndStickerInfo from './PackageAndStickerInfo'
import {
  usePackageInfo,
  usePutPackageStatus,
} from '../../hooks/reactQuery/usePackage'

import styles from '../../styles/PackageWrapperWithStatus.module.css'
import { deletePkg } from '../../api/parseApi'
import { useIsMutating } from 'react-query'
import { notiFormForError } from '../../components/notificationForm'
import rootHistory from '../../rootHistory'
import { useEffect } from 'react'

const PackageWrapperWithStatus = ({ packageId }: { packageId: string }) => {
  const user = useUserWithRedirect()
  const intl = useIntl()
  const {
    data: packageAndSticker,
    error,
    isLoading,
  } = usePackageInfo(packageId, user?.sessionToken)
  const setPackageEdit = usePutPackageStatus(packageId)

  const handleSubmit = () => {
    if (user) {
      setPackageEdit.mutate({
        packageId,
        sessionToken: user?.sessionToken,
      })
    }
  }
  const packageMutating = useIsMutating(packageId)
  if (!packageAndSticker) return <></>
  if (error) {
    notiFormForError(
      intl.locale,
      intl.formatMessage({ id: 'Upload.packages.serverError' }),
    )
  }
  return (
    <Spin spinning={packageMutating > 0}>
      <div className={styles.header}>
        <FormattedMessage
          id={
            packageAndSticker.status === 'under review'
              ? `PkgStatus.underReview`
              : packageAndSticker.status === 'pre deleted'
              ? 'PkgStatus.unapproved'
              : `PkgStatus.${packageAndSticker.status}`
          }
        />
        <span> 팩</span>
      </div>
      <Divider />
      <div style={{ margin: '24px 25px 24px 25px' }}>
        <PackageAndStickerInfo packageInfo={packageAndSticker} />
      </div>
      <div>
        {['unapproved', 'pre deleted'].includes(packageAndSticker.status) && (
          <div className={styles.submitButtonWrapper}>
            <Button onClick={handleSubmit} className={styles.submitButton}>
              수정해서 다시 제출
            </Button>
          </div>
        )}
      </div>
      {packageAndSticker.status === 'pre deleted' && (
        <div className="package-deleted-wapper">
          <FormattedHTMLMessage
            id={'PkgAndStickerInfo.pkgDelete.message'}
            defaultMessage={
              '<div><span class="caution-mark">*</span> If all stickers in the pack fall under Reject Reasons C-G, we recommend deleting the pack.</div>'
            }
          />

          <Popconfirm
            placement="top"
            title={
              <FormattedHTMLMessage
                id={'PkgAndStickerInfo.pkgDelete.popconfirm.message'}
                defaultMessage={
                  '<b>Delete Rejected Pack</b><div class="deleted-package-popconfirm">Click the \'Delete\' button below to delete the pack.<br/>Please make and submit a new pack.</div>'
                }
              />
            }
            okText={
              <FormattedMessage
                id={'Popconfirm.okText.delete'}
                defaultMessage={'Delete'}
              />
            }
            cancelText={
              <FormattedMessage
                id={'Popconfirm.cancelText'}
                defaultMessage={'Cancel'}
              />
            }
            icon={
              <Icon
                type="exclamation-circle"
                theme="filled"
                style={{ marginTop: 3 }}
              />
            }
            onConfirm={() =>
              deletePkg(packageAndSticker.objectId).catch(() =>
                notiFormForError(
                  intl.locale,
                  intl.formatMessage({ id: 'Upload.packages.serverError' }),
                ),
              )
            }
          >
            <Button
              style={{ borderRadius: 5, margin: '15px 25px' }}
              className="btn-style-primary"
            >
              <FormattedMessage
                id={'PkgAndStickerInfo.btn.pkgDelete'}
                defaultMessage={'Delete the Pack'}
              />
            </Button>
          </Popconfirm>
        </div>
      )}
    </Spin>
  )
}
export default PackageWrapperWithStatus
